import React from 'react';
import { useTranslation } from 'react-i18next';

import { InputHandler } from '../../../../../viewer/input-handler';
import { SubscriptionTopic } from '../../../../../viewer/messaging/pubsub';
import { useNonce } from '../../../../hooks/use-nonce';
import { useSubscribe } from '../../../../hooks/use-subscribe';
import { ToolIcon } from '../tool-icon';

const InspectOriginalPhotosToolIcon = () => {
  const { t } = useTranslation();
  const [_, refresh] = useNonce();

  useSubscribe(SubscriptionTopic.SetTool, refresh);

  const isActive = InputHandler.instance.isInspectionToolActive() ?? false;

  return (
    <ToolIcon
      active={isActive}
      callback={() => {
        InputHandler.instance.setTool('inspection');
        refresh();
      }}
      icon={['fal', 'magnifying-glass-plus']}
      tooltip={{
        title: t('inspectOriginalPhotos.tooltip.title', { ns: 'skyviewToolbar' }),
        text: t('inspectOriginalPhotos.tooltip.text', { ns: 'skyviewToolbar' }),
      }}
    />
  );
};

export { InspectOriginalPhotosToolIcon };
